import { TextField, makeStyles } from '@material-ui/core'
import debounce from 'lodash/debounce'
import { FC, memo, useMemo, useState } from 'react'

const useStyles = makeStyles(() => ({
  input: {
    width: '300px',
    margin: '10px 0'
  }
}))

interface Props {
  onChange: (value: string) => void
}

const SearchBox: FC<Props> = ({ onChange }) => {
  const classes = useStyles()
  const [localQuery, setLocalQuery] = useState('')

  const change = useMemo(
    () =>
      debounce((input: string) => {
        onChange(input)
      }, 1000),
    []
  )

  return (
    <TextField
      type='search'
      label='Search'
      value={localQuery}
      className={classes.input}
      onChange={(e) => {
        setLocalQuery(e.target.value)
        if (e.target.value.length !== 1) {
          change(e.target.value)
        }
      }}
    />
  )
}

export default memo(SearchBox)
